import { useState } from "react";
import { Logo } from "../Logo";
import api, { fmtErr } from "../../lib/api";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-6" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="card-surface w-full max-w-md p-8 sm:p-10"
      >
        <Logo />
        <h1 className="mt-8 font-heading text-3xl font-extrabold tracking-tight text-ink">
          Admin Sign In
        </h1>
        <p className="mt-2 text-sm text-soot">Audit review dashboard access.</p>
        <div className="mt-8 space-y-6">
          <div>
            <label htmlFor="admin-email" className="field-label">Email</label>
            <input
              id="admin-email"
              type="email"
              required
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-input"
              autoComplete="email"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="field-label">Password</label>
            <input
              id="admin-password"
              type="password"
              required
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-input"
              autoComplete="current-password"
            />
          </div>
        </div>
        {error && (
          <p data-testid="admin-login-error" role="alert" className="mt-5 rounded-2xl bg-red-50 p-3.5 text-sm font-medium text-red-700">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="btn-primary mt-8 w-full disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};
